export enum OptInSource {
  WEB = 'WEB',
  BACKOFFICE = 'BACKOFFICE',
  DOCUMENT = 'DOCUMENT',
  THIRD_PARTY = 'THIRD_PARTY',
}
